var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"tw-inline-flex tw-items-center tw-p-2 tw-text-sm lg:tw-text-base tw-bg-slate-800 tw-text-white tw-opacity-[.72] lg:hover:tw-opacity-[.88] tw-h-full hover:tw-cursor-pointer",class:( _obj = {}, _obj["media-counter--disabled"] = _vm.disabled, _obj['media-counter--clickable'] =  _vm.clickable, _obj ),on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }